import { SaveWelcomeDatаResponse } from '../api/RestApiManager';
import { DEFAULT_BANNER_PARAMS, WelcomeBannerParams } from '../typings/welcome';

export function mapWelcomeBannerType(data: SaveWelcomeDatаResponse): WelcomeBannerParams {
    if (data && data.flags) {
        const { flags } = data;

        return {
            suggestExternalService: Boolean(flags.suggest_non_yandex_service),
            suggestYandexService: Boolean(flags.suggest_yandex_service),
            suggestAgencyService: false
        };
    }

    return DEFAULT_BANNER_PARAMS;
}
